module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/259.0ee73093.png";